import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'
import { CURRENT_ENV, Env, IS_PRIVATE } from '@/common/const/env'
import { getLocale } from '@/i18n'

/** 私有化生产环境，用于调试的api origin */
const DEBUG_PRIVATE_API_ORIGIN = localStorage.getItem('DEBUG_PRIVATE_API_ORIGIN')

const SASS_TEST_ORIGIN =  location.protocol.toLowerCase().includes('https')
  ? '//test-teamconsole.zhhainiao.com'
  : '//test-teamconsole.zhhainiao.com'

/** 日文界面 / 日文专版在 SaaS 生产环境使用的控制台 API 域名 */
const SAAS_JP_RELEASE_ORIGIN = 'https://teamconsole.kingsoft.jp'

export const SAAS_API_ORIGIN = {
  develop: SASS_TEST_ORIGIN,
  test: SASS_TEST_ORIGIN,
  release: '//teamconsole.zhhainiao.com',
}

export const PRIVATE_API_ORIGIN = {
  // develop: window.location.host=== 'localhost' ? 'https://10.12.33.61:10082' : 'https://10.12.33.199:10082', // 本地调试级联登录用
  develop: 'https://192.168.31.42:10082',
  test: 'https://192.168.31.42:10082',
  release: DEBUG_PRIVATE_API_ORIGIN || `//${location.host}`,
}

function resolveEffectiveSassApiOrigin (): string {
  if (CURRENT_ENV !== Env.release) {
    return SAAS_API_ORIGIN[CURRENT_ENV]
  }
  if (IS_JP_ONLY_BUILD) {
    return SAAS_JP_RELEASE_ORIGIN
  }
  return SAAS_API_ORIGIN.release
}

/** 当前请求应使用的 API 域（SaaS 生产下会随界面语言在中日控制台间切换） */
export function getApiOrigin (): string {
  if (IS_PRIVATE) {
    return PRIVATE_API_ORIGIN[CURRENT_ENV]
  }
  return resolveEffectiveSassApiOrigin()
}

export function getBaseUrl () {
  const origin = getApiOrigin()
  if (IS_PRIVATE) {
    return `${origin}/teamconsole/api`
  }
  return `${origin}/api`
}

export function getTeamServerBaseUrl () {
  if (IS_PRIVATE) {
    return `${getApiOrigin()}/teamserver`
  }
  return '//teamserver.zhhainiao.com'
}
